<div class="modal-header">
  <div class="top">
    <div class="left-side">
      <i class="icon ic-form-20"></i>

      <div class="title">
        <h2 class="h2-heading mb-0" [title]="header">{{ header }}</h2>
        <p class="sub-heading" [title]="subheader">{{ subheader }}</p>
      </div>
    </div>
    <div class="right-side">
      <div class="steps-controls">
        <ng-content select=".step-control"></ng-content>

        <app-button
          iconClass="icon ic-close-20"
          btnColor="white"
          [isDisabled]="isLoading"
          (clickBtn)="closeModal()"
        ></app-button>

        <app-button
          iconClass="icon ic-arrow-left-20"
          btnColor="white"
          [isDisabled]="isLoading || currentStepIndex === 0"
          (clickBtn)="setPreviousStep()"
        ></app-button>

        <div class="separator"></div>

        @if (currentStepIndex < (steps.length - 1)) {
          <app-button
            #nextStepButton
            class="next-step-button"
            iconClassLast="icon ic-arrow-right-20"
            text="Next Step"
            [isDisabled]="isCurrentStepInvalid"
            (clickBtn)="setNextStep()"
          ></app-button>
        } @else {
          <ng-content select=".submit-control"></ng-content>

          <app-button
            class="apply-changes-button"
            [hidden]="hideApplyChangesButton"
            [loading]="isApplyChangesLoading && isLoading"
            [isDisabled]="isFormInvalid || isLoading"
            [text]="applyChangesButtonText"
            (clickBtn)="applyChanges.emit()"
          ></app-button>

          <app-button
            #submitButton
            class="submit-button"
            iconClass="icon ic-generate-documents-20 mr-2"
            [isDisabled]="isFormInvalid || isLoading"
            [loading]="isLoading && !isSaveAndCompleteLaterLoading"
            [text]="submitButtonText"
            (clickBtn)="confirm.emit()"
          ></app-button>
        }
      </div>
    </div>
  </div>

  @if (showSteps) {
    <div class="bottom">
      <app-clickable-stepper
        [currentStepIndex]="currentStepIndex"
        [disableSteps]="isLoading"
        [steps]="steps"
        (stepIndexChange)="setCurrentStep($event)"
      />
    </div>
  }
</div>
<div class="modal-body">
  <form id="stepper-body" (submit)="$event.preventDefault(); onSubmit()">
    <ng-content></ng-content>
    <button class="hidden p-0" tabindex="-1" type="submit">submit</button>
  </form>

  <!-- a button which redirects focus -->
  <button class="hidden p-0" (focusin)="returnFocus()"></button>
</div>

